import React, { useState } from "react";
import { Layout, Menu } from "antd";
import type { MenuProps } from "antd";
import {
  UserOutlined,
  NotificationOutlined,
  SettingOutlined,
  HomeOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import PastOrders from "./PastOrders";
import Profile from "./Profile";
import Notifications from "./Notifications";
import Addresses from "./Addresses";
// import './UserHomePage.scss';

const { Sider, Content } = Layout;

type MenuKey = "pastOrders" | "profile" | "notification" | "addresses" | "settings";

const items: { key: MenuKey; label: string; icon: React.ReactNode }[] = [
  { key: "pastOrders", label: "Past Orders", icon: <HomeOutlined /> },
  { key: "profile", label: "Profile", icon: <UserOutlined /> },
  { key: "notification", label: "Notification", icon: <NotificationOutlined /> },
  { key: "addresses", label: "Addresses", icon: <ProfileOutlined /> },
  { key: "settings", label: "Settings", icon: <SettingOutlined /> },
];

const UserHomePage: React.FC = () => {
  const [selectedKey, setSelectedKey] = useState<MenuKey>("pastOrders");

  const onClick: MenuProps["onClick"] = (e) => {
    setSelectedKey(e.key as MenuKey);
  };

  return (
    <Layout style={{ minHeight: "100vh", padding:"0px" }}>
      <Sider
        width={320}
        style={{
          background: "#fff",
          borderRight: "1px solid #f0f0f0",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={onClick}
          style={{ borderRight: 0 }}
          className="user-siderail"
          items={items.map((item) => ({
            key: item.key,
            label: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: 63,
                  padding: "0 16px",
                  position: "relative",
                  background:
                    selectedKey === item.key
                      ? "linear-gradient(270deg, rgba(195, 35, 64, 0.15) 0%, rgba(195, 35, 64, 0) 98.77%)"
                      : "transparent",
                  color: selectedKey === item.key ? "#C32340" : "rgba(0,0,0,0.6)",
                  fontWeight: 500,
                  fontSize: 16,
                }}
              >
                {/* <span style={{ marginRight: 10 }}>{item.icon}</span> */}
                {item.label}

                {selectedKey === item.key && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      width: 7,
                      height: "100%",
                      background: "#C32340",
                    }}
                  />
                )}
              </div>
            ),
          }))}
        />
      </Sider>

      <Layout>
        <Content
          style={{
            background: "#fff",
            padding: 24,
            minHeight: 280,
          }}
        >
          {selectedKey === "pastOrders" && <PastOrders/>}
          {selectedKey === "profile" && <Profile/>}
          {selectedKey === "notification" && <Notifications/>}
          {selectedKey === "addresses" && <Addresses/>}
          {selectedKey === "settings" && <div>Settings Component</div>}
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserHomePage;
